var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "full-height",
      staticStyle: { padding: "20px", "padding-bottom": "0", height: "100%" },
    },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.panel,
            callback: function ($$v) {
              _vm.panel = $$v
            },
            expression: "panel",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "項目設定", name: "item" } }),
          _c("el-tab-pane", { attrs: { label: "分類設定", name: "type" } }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", disabled: _vm.listLoading },
                      on: { click: _vm.addData },
                    },
                    [_vm._v("建立")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "ID", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.id))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "標題", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.title))])]
                    },
                  },
                ]),
              }),
              _vm.panel == "item"
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "code", width: "110" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.code))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2012011659
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { align: "center", label: "排序", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.sort))])]
                    },
                  },
                ]),
              }),
              _vm.panel == "item"
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "種類", width: "300" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.changeShowType(scope.row.types))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3480682961
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v("編輯")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "刪除", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope)
                              },
                            },
                          },
                          [_vm._v("刪除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { border: "2px solid #ccc" },
          attrs: {
            title:
              _vm.formData.id !== undefined && _vm.formData.id !== null
                ? "編輯【" + _vm.dialogTitle + "】"
                : "新增",
            visible: _vm.dialogFormVisible,
            width: "50%",
            top: "1%",
          },
          on: {
            closed: _vm.onDialogClosed,
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              staticClass: "box-card",
              attrs: { "body-style": { border: "1px solid #ccc" } },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "dynamicValidateForm",
                          attrs: { model: _vm.formData, rules: _vm.rules },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "標題",
                                "label-width": _vm.formLabelWidth,
                                prop: "title",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { autocomplete: "off" },
                                model: {
                                  value: _vm.formData.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "title", $$v)
                                  },
                                  expression: "formData.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.panel == "item"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "code",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "code",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: _vm.formData.code,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "code", $$v)
                                      },
                                      expression: "formData.code",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.panel == "item"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "分類",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "types",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        multiple: "",
                                        "collapse-tags": "",
                                        placeholder: "請選擇",
                                        "value-key": "id",
                                      },
                                      model: {
                                        value: _vm.formData.types,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "types", $$v)
                                        },
                                        expression: "formData.types",
                                      },
                                    },
                                    _vm._l(_vm.options, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.title,
                                          value: item,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "排序",
                                "label-width": _vm.formLabelWidth,
                                prop: "sort",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { autocomplete: "off", type: "number" },
                                model: {
                                  value: _vm.formData.sort,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "sort", $$v)
                                  },
                                  expression: "formData.sort",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveData("dynamicValidateForm")
                    },
                  },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }